module.exports = __webpack_public_path__ + "media/audio69.cc9cc07d.mp3";